import io from "socket.io-client";

const isDevelopment =
  import.meta.env.VITE_APP_ENV === "development";

const server = isDevelopment
  ? import.meta.env.VITE_APP_SOCKET_SERVER
  : import.meta.env.VITE_APP_SERVER;

export const socket = io(server, {
  path: isDevelopment
    ? "/socket.io"
    : "/meeting/socket.io",
  transports: ["websocket"],
});
